
function useSliderBreakpoints() {
  return {
    0: {
      slidesPerView: 2,
      spaceBetween: 13,
      slidesPerGroup: 2,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 13,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 13,
    },
  };
}

export {
  useSliderBreakpoints,
};
